import { render, staticRenderFns } from "./WithIconSlot.vue?vue&type=template&id=360a1892&scoped=true&"
import script from "./WithIconSlot.vue?vue&type=script&lang=js&"
export * from "./WithIconSlot.vue?vue&type=script&lang=js&"
import style0 from "./WithIconSlot.vue?vue&type=style&index=0&id=360a1892&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a1892",
  null
  
)

export default component.exports